export default __webpack_public_path__ + "6ea81ff.png";